module.exports = require('./accessors').LuminanceAccessor;